module.exports = __webpack_public_path__ + "static/media/12UNCTAD12.894cccd8.jpg";